import createReactClass from "create-react-class";
import React from "react";
import { Modal } from "react-bootstrap";
import { createRoot } from "react-dom/client";

export const ModalConfirm = createReactClass({
  displayName: "Modal",
  backdrop: function () {
    return <div className="modal-backdrop in" />;
  },

  modal: function () {
    var style = { display: "block" };
    return (
      <div
        className="modal in"
        tabIndex="-1"
        role="dialog"
        aria-hidden="false"
        ref="modal"
        style={style}
      >
        <div className="modal-dialog">
          <div className="modal-content">{this.props.children}</div>
        </div>
      </div>
    );
  },

  render: function () {
    return (
      <div>
        {this.backdrop()}
        {this.modal()}
      </div>
    );
  },
});

var Confirm = createReactClass({
  displayName: "Confirm",
  confirmRef: React.createRef(),
  getDefaultProps: function () {
    return {
      confirmLabel: "OK",
      abortLabel: "Cancel",
      showCheck: false,
    };
  },

  getInitialState() {
    return { boxChecked: false };
  },

  abort: function () {
    return this.props.promise.reject();
  },

  confirm: function () {
    return this.props.promise.resolve();
  },

  check: function (e) {
    this.setState({ boxChecked: e.target.checked });
  },

  componentDidMount: function () {
    this.boxChecked = true;
    if (this.confirmRef && this.confirmRef.current) {
      this.confirmRef.current.focus();
    }
  },

  render: function () {
    var modalBody;
    let checkbox = "";
    let disableConfirm = false;
    if (this.props.showCheck) {
      disableConfirm = !this.state.boxChecked;
      checkbox = (
        <div>
          I acknowledge this is an active Form B restriction that is being
          voided
          <input
            id="voidFormConfirm"
            type="checkbox"
            name="voidFormConfirm"
            style={{ marginLeft: "5px" }}
            checked={this.state.boxChecked}
            onChange={this.check}
          />
        </div>
      );
    }

    if (this.props.description) {
      modalBody = (
        <div className="modal-body">
          {this.props.description}
          {checkbox}
        </div>
      );
    }

    return (
      <Modal show>
        <div className="modal-header">
          <h4 className="modal-title">{this.props.message}</h4>
        </div>
        {modalBody}
        <div className="modal-footer">
          <div className="text-right">
            <button
              role="abort"
              type="button"
              className="btn btn-default"
              onClick={this.abort}
            >
              {this.props.abortLabel}
            </button>{" "}
            <button
              role="confirm"
              type="button"
              className="btn btn-primary"
              ref={this.confirmRef}
              disabled={disableConfirm}
              onClick={this.confirm}
            >
              {this.props.confirmLabel}
            </button>
          </div>
        </div>
      </Modal>
    );
  },
});

//overwrites the window.confirm method to give a custom confirm dialog
var register = function () {
  window.confirm = function (message, options = {}) {
    const props = { message, ...options, promise: new $.Deferred() };

    const divTag = document.createElement("div");
    divTag.setAttribute("id", "confirm-dialog-box");
    document.body.appendChild(divTag);

    const wrapper = document.getElementById("confirm-dialog-box");
    const root = createRoot(wrapper)
    root.render(<Confirm {...props} />);

    return props.promise.always(function () {
      root.unmount();
    }).promise();
  };
};

export { register as registerModal };

